import React from "react";
import PropTypes from "prop-types";

import "./GuidelinesItem.css";

import { Subtitle, Text } from "./../../../StyledComponents";

export const GuidelinesItem = ({ icon, title, message }) => {
  if (!title || !message) {
    return null;
  }

  const Icon = icon;

  return (
    <div className="guidelines-item">
      <div className="header-container">
        {!!Icon && <Icon />}
        <Subtitle style={{ marginTop: 0 }}>{title}</Subtitle>
      </div>
      <Text className="message">{message}</Text>
    </div>
  );
};

GuidelinesItem.prototype = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};
